/* Native details remain functional without JavaScript. This adds dismissal,
   keyboard navigation and clean Shopify editor section lifecycles only. */
(() => {
  if (window.effyShellInitialized) return;
  window.effyShellInitialized = true;

  const instances = new Map();

  function initialize(root) {
    if (instances.has(root)) return;
    const controller = new AbortController();
    const { signal } = controller;
    const menus = Array.from(root.querySelectorAll('[data-effy-menu]'));
    const mobile = root.querySelector('[data-effy-mobile]');
    const summaryFor = details => details.querySelector(':scope > summary');
    const linksFor = menu => Array.from(menu.querySelectorAll('.effy-shell__dropdown a'));

    function closeMenus(except) {
      menus.forEach(menu => { if (menu !== except) menu.open = false; });
    }

    function closeMobile(restoreFocus = false) {
      if (!mobile || !mobile.open) return;
      mobile.open = false;
      closeMenus();
      if (restoreFocus) summaryFor(mobile).focus();
    }

    menus.forEach(menu => {
      const summary = summaryFor(menu);
      menu.addEventListener('toggle', () => {
        if (menu.open) closeMenus(menu);
      }, { signal });

      summary.addEventListener('keydown', event => {
        if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp') return;
        event.preventDefault();
        event.stopPropagation();
        closeMenus(menu);
        menu.open = true;
        const links = linksFor(menu);
        (event.key === 'ArrowUp' ? links.at(-1) : links[0])?.focus();
      }, { signal });

      menu.addEventListener('keydown', event => {
        if (event.key === 'Escape' && menu.open) {
          event.preventDefault();
          event.stopPropagation();
          menu.open = false;
          summary.focus();
          return;
        }
        const links = linksFor(menu);
        const index = links.indexOf(document.activeElement);
        if (index < 0) return;
        let nextIndex;
        if (event.key === 'ArrowDown') nextIndex = (index + 1) % links.length;
        if (event.key === 'ArrowUp') nextIndex = (index - 1 + links.length) % links.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = links.length - 1;
        if (nextIndex !== undefined) {
          event.preventDefault();
          links[nextIndex].focus();
        }
      }, { signal });

      menu.addEventListener('focusout', event => {
        // Touch activation of a nested summary can clear focus without moving
        // it elsewhere. Only a known destination outside this menu dismisses it.
        if (event.relatedTarget instanceof Node && !menu.contains(event.relatedTarget)) {
          menu.open = false;
        }
      }, { signal });
    });

    root.addEventListener('keydown', event => {
      if (event.key === 'Escape' && mobile?.open) {
        event.preventDefault();
        closeMobile(true);
      }
    }, { signal });

    root.addEventListener('click', event => {
      if (!(event.target instanceof Element)) return;
      if (event.target.closest('.effy-shell__mobile-panel a')) closeMobile();
    }, { signal });

    document.addEventListener('click', event => {
      if (!(event.target instanceof Node)) return;
      menus.forEach(menu => { if (!menu.contains(event.target)) menu.open = false; });
      if (mobile && !mobile.contains(event.target)) closeMobile();
    }, { signal });

    if (mobile) {
      mobile.addEventListener('toggle', () => {
        if (!mobile.open) closeMenus();
      }, { signal });
      mobile.addEventListener('focusout', event => {
        if (event.relatedTarget instanceof Node && !mobile.contains(event.relatedTarget)) {
          closeMobile();
        }
      }, { signal });
    }

    const breakpoint = window.matchMedia('(min-width: 1000px)');
    breakpoint.addEventListener('change', () => {
      const focusWasInside = root.contains(document.activeElement);
      closeMenus();
      closeMobile();
      if (focusWasInside) root.querySelector('.effy-shell__brand')?.focus();
    }, { signal });

    instances.set(root, controller);
  }

  function scan(container = document) {
    if (container.matches?.('[data-effy-header]')) initialize(container);
    container.querySelectorAll('[data-effy-header]').forEach(initialize);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => scan(), { once: true });
  } else {
    scan();
  }

  document.addEventListener('shopify:section:load', event => scan(event.target));
  document.addEventListener('shopify:section:unload', event => {
    instances.forEach((controller, root) => {
      if (event.target === root || event.target.contains(root)) {
        controller.abort();
        instances.delete(root);
      }
    });
  });
})();

/* Keep the floating signup teaser clear of mobile collection and search controls.
   The actual signup form and the desktop teaser remain unchanged. */
(() => {
  function prepareMobileBrowsePromo() {
    if (!document.body.matches(".collection, .search")) return;
    let attempts = 0;
    function attachStyle() {
      const host = document.getElementById("app-embed-container-341749");
      const shadow = host && host.shadowRoot;
      if (shadow) {
        if (!shadow.getElementById("effy-mobile-browse-teaser")) {
          const style = document.createElement("style");
          style.id = "effy-mobile-browse-teaser";
          style.textContent = "@media (max-width: 599px) { [data-form-root][data-current-step=\"tease\"] { display: none !important; } }";
          shadow.appendChild(style);
        }
        return;
      }
      if (++attempts < 60) window.setTimeout(attachStyle, 500);
    }
    attachStyle();
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", prepareMobileBrowsePromo, { once: true });
  } else {
    prepareMobileBrowsePromo();
  }
})();
